import VertragsKontoMixin from "./VertragsKontoMixin";

// @vue/component
export default {
  name: "VertragsKonto",
  mixins: [
    VertragsKontoMixin,
  ],
};
